import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material";
import { api } from "../../../../axios/api";
import TransferHistory from "./TransferHistory";
import { useSelector } from "react-redux";

const ViewNotes = ({ selectedLead, setViewMode }) => {
  const [notes, setNotes] = useState([]);
  const user = useSelector((state) => state.user);
  const theme = useTheme();
  useEffect(() => {
    console.log("runnibg useefeect");
    api
      .get("/relationshipsNotes/" + selectedLead?.info_reference_number)
      .then((res) => {
        console.log("res", res?.data);
        setNotes(res?.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const [showTransferHistory, setShowTransferHistory] = useState(false);

  return (
    <Box>
      <Box sx={{ p: "2", display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ mt: { xs: 3, sm: 1 }, mr: 2 }}
          onClick={() => setViewMode(false)}
        >
          Add a Note
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ mt: { xs: 3, sm: 1 } }}
          onClick={() =>
            showTransferHistory
              ? setShowTransferHistory(false)
              : setShowTransferHistory(true)
          }
        >
          {showTransferHistory ? "View Leads Notes" : " View Transfer Notes"}
        </Button>
      </Box>
      {showTransferHistory ? (
        <>
          <TransferHistory selectedLead={selectedLead} />
        </>
      ) : (
        <>
          <Box
            sx={{ mt: 2, display: "flex", alignItems: "center", gap: "20px" }}
          >
            <Typography variant="p">Total No. of Notes= </Typography>
            <Typography
              variant="p"
              sx={{
                fontSize: "1.3rem",
                fontWeight: "600",
                // color: theme.palette.primary.main,
              }}
            >
              {notes?.length}
            </Typography>
          </Box>
          <Box sx={{ mt: 2, p: 2, background: "white" }}>
            <Typography variant="h6" sx={{ color: theme.palette.heading.main }}>
              Notes for the lead: {selectedLead?.contact_person}
            </Typography>
            <Box sx={{ mt: 3 }}>
              {notes?.map((n, i) => (
                <NoteBox note={n} i={i} />
              ))}
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ViewNotes;

const NoteBox = ({ note, i }) => {
  const [from, setFrom] = useState({});
  const user = useSelector((state) => state.user);
  const theme = useTheme();

  useEffect(() => {
    api
      .get("/getUserById/" + note?.uploaded_by)
      .then((res) => setFrom(res?.data))
      .catch((err) => console.log(err));
  }, []);
  return (
    <Box
      sx={{
        mb: 2,
        p: 1,
        background: theme.palette.selectedMenuBack.main,
        borderRadius: "3px",
        maxWidth: "500px",
      }}
    >
      <Box>
        <Typography sx={{ color: theme.palette.primary.main }}>
          {note?.note}
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <Typography variant="body2" sx={{ color: theme.palette.para?.main }}>
          {from?.id == user?.id ? "You" : from?.name}
        </Typography>
        <Typography variant="body2" sx={{ color: theme.palette.para?.main }}>
          {new Date(note?.date_of_upload)?.toDateString()}
        </Typography>
      </Box>
    </Box>
  );
};
